<lg-navbar-main />
<lg-navbar-chantier />
<lg-navbar-secondary-menu />
<!-- Version mobile, avec les swipes gauche droite -->
@if (!deviceService.isDesktop()) {
  <div class="main-and-footer-container" (swipeleft)="navigateToRightPage()"
    (swiperight)="navigateToLeftPage()">
    <div class="container" style="flex-grow: 1">
      <router-outlet />
    </div>
    <lg-footer />
  </div>
}

<!-- Version desktop, sans les swipes gauche droite -->
@if (deviceService.isDesktop()) {
  <div class="main-and-footer-container">
    <div class="container" style="flex-grow: 1">
      <router-outlet />
    </div>
    <lg-footer />
  </div>
}

